const Data =[
    {
        name: "Prerit Jain",
        position: "Chief Executive Officer, LiGHT",
        imageUrl: "/assets/images/members/Heads21/Prerit Jain.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Pratik Banka",
        position: "Public Relations Officer",
        imageUrl: "/assets/images/members/Heads21/Pratik Banka.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Ravi Kumar Meena",
        position: "Social Strategy Development Officer",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Nitish Kumar",
        position: "Human Resource and Network Management Officer",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
]

export default Data;